module.exports = __webpack_public_path__ + "img/cloud-hail-lightning-moon.d593a5be.svg";